export { default as AuthOverlay } from './AuthOverlay';
export {
  openAuth,
  closeAuth,
  setAuthMode,
  isAuthOverlayOpen,
  consumeOverlayBackBypass
} from './auth-overlay';
export type { TAuthMode } from '@/store/auth.slice';
